import { render, staticRenderFns } from "./Right.vue?vue&type=template&id=18e2e240&scoped=true"
import script from "./Right.vue?vue&type=script&lang=js"
export * from "./Right.vue?vue&type=script&lang=js"
import style0 from "./Right.vue?vue&type=style&index=0&id=18e2e240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e2e240",
  null
  
)

export default component.exports